export const MULTI_ACT_FILE_TYPE = 'MULTI_ACT_FILE_TYPE';

export const MULTI_ACT_FILE_READY_FOR_UPLOAD = 'MULTI_ACT_FILE_READY_FOR_UPLOAD';
export const MULTI_ACT_FILE_UPLOAD_ERROR = 'MULTI_ACT_FILE_UPLOAD_ERROR';
export const MULTI_ACT_INITIATE_NAM_OCR = 'MULTI_ACT_INITIATE_NAM_OCR';

export const MULTI_ACT_UPDATE_PICTURE = 'UPDATE_MULTI_ACT_PICTURE';
